// EXTERNAL IMPORTS
import React, { Component } from "react";
import PropTypes from "prop-types";
import { themr } from "react-css-themr";
import { Button, modal } from "@lifepay/rc-ui-toolkit";
import groupBy from "lodash.groupby";
import sortby from "lodash.sortby";
import map from "lodash.map";
import reduce from "lodash.reduce";
import assign from "lodash.assign";
import { Lock } from "@lifepay/redux-subsystem-access";

// ABSOLUTE PATH IMPORTS
import queryFactory, { cardLimits, limitGroups } from "model/gql/queries";

// RELATIVE PATH IMPORTS
import { LOCK_KEYS } from "accessConfig";
import CardLimits from "../../limits/CardLimits";
import styles from "./CardLimitsControl.m.scss";

const CardLimitsData = queryFactory(cardLimits);
const LimitGroupsData = queryFactory(limitGroups);

@themr("@lifepay/CardLimitsControl", styles)
export default class CardLimitsControl extends Component {
  // declaring props passed to the component
  static propTypes = {
    theme: PropTypes.object,
    isValid: PropTypes.bool,
    cardId: PropTypes.string,
    onSuccess: PropTypes.func,
  };

  constructor(props) {
    super(props);

    this.state = {
      blockReasonId: "3",
      blockComment: "",
      loading: false,
      error: null,
      submitButtonState: "normal",
    };
  }

  render() {
    const { theme, cardId } = this.props;
    return (
      <modal.ModalController>
        {({ isOpen, close, open }) => {
          return (
            <React.Fragment>
              <Lock
                lockId={LOCK_KEYS.CARD_LIMITS_VIEW}
                type={"lock"}
                theme={{
                  wrapper: theme.button,
                }}
              >
                <Button type={"alt"} size={"small"} onClick={open}>
                  {"Лимиты по карте"}
                </Button>
              </Lock>
              <modal.ModalBox
                isOpen={isOpen}
                close={() => {
                  close();
                }}
                theme={{
                  inner: theme.modal,
                }}
              >
                <LimitGroupsData skip={true}>
                  {({
                    data: limitGroupsData,
                    loaded: limitGroupsDataLoaded,
                  }) => (
                    <CardLimitsData cardId={cardId} skip={!isOpen}>
                      {({ data, loaded }) => {
                        const groups = limitGroupsDataLoaded
                          ? reduce(
                              limitGroupsData.limitGroups,
                              (acc, { id, name }) =>
                                assign(acc, { [id]: name }),
                              {}
                            )
                          : null;
                        if (!data) {
                          return null;
                        }
                        const groupedLimits = data.cardLimits
                          ? sortby(
                              map(
                                groupBy(data.cardLimits, "groupLimitId"),
                                (limits) => ({
                                  id: limits[0].groupLimitId,
                                  name: groups
                                    ? groups[limits[0].groupLimitId]
                                    : limits[0].groupLimitName,
                                  limits,
                                })
                              ),
                              "id"
                            )
                          : [];
                        return data ? (
                          <CardLimits
                            cardId={cardId}
                            loading={data.loading}
                            loaded={loaded}
                            groupedLimits={groupedLimits}
                            limitGroups={
                              limitGroupsDataLoaded
                                ? limitGroupsData.limitGroups
                                : null
                            }
                            refetch={data.refetch}
                          />
                        ) : null;
                      }}
                    </CardLimitsData>
                  )}
                </LimitGroupsData>
              </modal.ModalBox>
            </React.Fragment>
          );
        }}
      </modal.ModalController>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/emission/cards/controls/CardLimitsControl/CardLimitsControl.js